/**
 * Facebook and Instagram glyphs, exported from the Figma design (Social Media Agent → channel
 * chips) rather than taken from an icon set.
 *
 * The colour is baked into the assets at the design's `Icons/Secondary` (#5f656f) — the chips are
 * only ever rendered on the subtle grey pill, so there is nothing to recolour.
 */

export function InstagramIcon({ className }: { className?: string }) {
	return <img src='/assets/brand/instagram.svg' className={className} alt='' aria-hidden='true' />;
}

export function FacebookIcon({ className }: { className?: string }) {
	return <img src='/assets/brand/facebook.svg' className={className} alt='' aria-hidden='true' />;
}
